import Highcharts from 'highcharts'

export default {
  props: {
    data: {
      type: Object,
      required: true
    },
    id: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      numberOfBlades: 2
    }
  },
  watch: {
    data () {
      if (this.dataAvailable()) {
        this.rerender()
      }
    }
  },
  methods: {
    rerender () {
      Highcharts.chart(this.id, {
        chart: {
          type: 'column',
          backgroundColor: '#F1F6E4'
        },
        credits: {
          enabled: false
        },
        title: {
          text: ''
        },
        xAxis: {
          categories: this.getLabels(),
          title: {
            enabled: true,
            text: this.$t('charts.xAxis')
          }
        },
        yAxis: {
          title: {
            text: ''
          }
        },
        series: this.getSeries()
      })
    },
    getTitle () {
      return ''
    },
    getLabels () {
      let labels = []
      this.iterate(0, (f) => labels.push(f))
      labels = labels.map(this.labelMap)
      return labels
    },
    dataMap (f) {
      return f.staticStress
    },
    labelMap (value) {
      return this.$t('hours.' + value.label)
    },
    getSeries () {
      const series = []
      for (let i = 0; i < this.numberOfBlades; i++) {
        const values = []
        this.iterate(i, (f) => values.push(f))
        series.push({
          name: this.$t('charts.labels.blades.label') + ' ' + (i + 1),
          data: values.map(this.dataMap)
        })
      }
      return series
    },
    iterate (bladeNumber, callback) {
      const bladeData = this.getBladeData(bladeNumber)
      for (const value of bladeData) {
        if (this.filter(value, bladeNumber)) {
          callback(value)
        }
      }
    },
    getBladeData (bladeNumber) {
      return this.data.frequencyMap.blades[bladeNumber].frequencies
    },
    filter (value) {
      return value.label !== 'start'
    },
    dataAvailable () {
      return !!this.data.frequencyMap
    }
  },
  mounted () {
  }
}
